<template>
    <div>
        <div class="addressBox">
            <div class="account" style="display: flex; align-items: center">
                <img style="width: 16px; margin-right: 5px; height: 16px;border-radius: 50%;"
                    :src="netWorkConfig.logoURI" alt="" />
                {{ netWorkConfig.NetWorkName }}
            </div>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import { NetConfig } from '@/config/constants/netWorkConfig.js';
import { watch } from 'less';
export default {
    data() {
        return {
            showPopover: false,
            NetConfig
        }
    },
    watch: {
        netWorkConfig(newd, old) {

            if (newd.chainId != old.chainId) {
                window.location.reload();
            }


        }
    },
    computed: {
        ...mapState(['netWorkConfig']),

    },
    components: {

    },
    mounted() {

    },
    methods: {
        Change(item) {
            this.$store.commit('SETNETWORKCINFIG', item);
            this.showPopover = false
        },
    },
}

</script>
<style scoped lang='less'>
/deep/.van-popover__content {
    background: #241D19 !important;
}

.addressBox {
    margin-left: 12px;
    padding: 5px;
    border-radius: 10px;
    background: #241D19;
    border: 1px solid #AD5732;
    // padding: 5px;
    display: flex;
    align-items: center;
    font-size: 12px;
    color: #FFFFFF;
    font-weight: 500;
}

.popoverBox {
    width: 150px;
    background: #241D19;

    .popoverBox_title {
        padding: 5px 5px 5px 10px;
        font-size: 14px;
        font-weight: bold;
        border-bottom: 1px solid rgb(102, 180, 174);
        padding-bottom: 5px;
        color: #FFF;
    }

    .popoverBox_item {
        padding: 6px;
        padding-left: 10px;
        display: flex;
        align-items: center;
        font-size: 16px;
        font-weight: bold;
        color: #FFF;

        .img {
            width: 20px;
            height: 20px;

            margin-right: 10px;

            img {
                width: 100%;
                border-radius: 50%;
                height: 100%;
            }
        }
    }
}
</style>